//
// SankeyDiagram.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../../lib";
import "../NodeLinkDiagram";
import "../../../data/ClassificationRole";
import "../../../data/Role";
import "../../../data/AnalysisRole";
import "../../../core/RelativeDirection";
import "./SankeyDiagramDisplay";
import "./LinkAlignment";
import "./VolumeBarType";
import "./VolumeLabelType";
import "../../../core/styles/TextAttributes";
import "../../../core/styles/LineAttributes";
import "../../../core/styles/FillAttributes";
import "../../../core/styles/FillPatternAttributes";

var SankeyDiagram = createModule("gtl_SankeyDiagram", [130,13,20148,20355,20098,20103,20353,20296,20361], EventDispatcher, [
    ,
    {
        toId: 1,
        nodeSecondaryDetails: [1],
        volumeLabelType: 4,
        nodeSecondaryDetailsAttributes: 1,
        type: 1,
        nodeLabelAttributes: 1,
        linkWidthResponse: 1,
        nodeDetailsAttributes: 1,
        linkFillPatternAttributes: 1,
        volumeLineAttributes: 1,
        direction: 4,
        nodeDetails: [1],
        linkAlignment: 4,
        display: 1,
        nodeType: 1,
        fromId: 1,
        nodeVolumeLabelsAttributes: 1,
        volumeBarType: 4,
        linkId: 1,
        nodeInputLabel: 1,
        nodeOutlineAttributes: 1,
        linkGroup: 1,
        selectionGroup: 1,
        nodeOutputLabel: 1,
        nodeId: 1,
        nodeLabel: 1,
        linkFillAttributes: 1,
    },
    ,
    ,
    {
        getResolvedDisplay: [1],
    },
    {
        _create: [4],
    },
    ,
]);
export default SankeyDiagram;
